
import axios from 'axios';
import {
  setAdvancePostingList,
  setLoading,
  setExportAdvancePosting,
  setExportLoading,
} from '../../../Redux/advancePosting/advancePostingSlice';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

const getAuthHeaders = () => {
  const bearerToken = UserAuthKey();
  return {
    Authorization: `Bearer ${bearerToken}`,
    'Content-Type': 'application/json',
  };
};

export const fetchAdvancePostingList = async ({ params, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/advance-posting/list`,
    headers: getAuthHeaders(),
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setAdvancePostingList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
  }
};

export const fetchAdvanceOrderDetails = async ({ reference_no, dispatch }) => {
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/advance-posting/get-order-details`,
    headers: getAuthHeaders(),
    data: {
      reference_no,
    }
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    throw error;
  }
};

export const addAdvancePosting = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}v1/advance-posting/add`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAdvancePostingStatus = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}v1/advance-posting/update`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const cancelAndAdvancePost = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}v1/advance-posting/cancel-and-advance-post`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const notifyMaterialNaCancelledItems = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}v1/advance-posting/notify-material-na-cancelled-items`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchExportAdvancePosting = async ({ params, dispatch }) => {
  dispatch(setExportLoading(true));
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/advance-posting/export-advance-posting`,
    headers: getAuthHeaders(),
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setExportAdvancePosting(response?.data));
  } catch (error) {
    dispatch(setExportLoading(false));
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

